import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
var ModalComponent = /** @class */ (function () {
    function ModalComponent(dialogRef, data, formBuilder, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
    }
    ModalComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalComponent.prototype.submit = function () {
        if (!this.formGroup.valid) {
            this.snackBar.open("Preencha corretamente os campos e tente novamente.");
            return false;
        }
        this.dialogRef.close(this.formGroup.value.cnpj);
    };
    ModalComponent.prototype.ngOnInit = function () {
        this.formGroup = this.formBuilder.group({
            cnpj: [null, [
                    Validators.required,
                    Validators.minLength(14),
                    Validators.maxLength(14),
                ]],
        });
    };
    return ModalComponent;
}());
export { ModalComponent };
